import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { ChevronIcon } from '../../images/icons/chevron';
import { colors } from '../../styles/constants';
import { Icon40 } from '../Icon';

const ChangeMonthButton = styled.button<{
  revert?: boolean;
  isDisabled?: boolean;
}>`
  ${tw`rounded-full bg-white border-solid  border-secondary-400 flex items-center justify-center`}
  ${Icon40}

  ${({ revert }) =>
    revert &&
    css`
      transform: rotateY(180deg);
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      visibility: hidden;
    `}
`;

interface ChangeMonthProps {
  revert?: boolean;
  onClick: () => void;
  isDisabled?: boolean;
  testid?: string;
}

const ChangeMonth: React.FC<ChangeMonthProps> = ({
  isDisabled,
  onClick,
  revert,
  testid,
}) => (
  <ChangeMonthButton
    data-testid={testid}
    disabled={isDisabled}
    isDisabled={isDisabled}
    onClick={onClick}
    revert={revert}
  >
    <ChevronIcon color={colors['secondary-400']} />
  </ChangeMonthButton>
);

const DatePickerHeaderContainer = styled.div`
  ${tw`sticky bg-white flex justify-between items-center`}
  top:0;
`;

const Title = styled.span`
  ${tw`font-kyrial text-title-large-m leading-title-large-m text-center`}
  text-transform: capitalize;
`;

interface DatePickerHeaderProps {
  onNextMonthClick: () => void;
  onPreviousMonthClick: () => void;
  title: string;

  isPrevMonthDisabled?: boolean;
  isNextMonthDisabled?: boolean;
}

const DatePickerHeader: React.FC<DatePickerHeaderProps> = ({
  isNextMonthDisabled,
  isPrevMonthDisabled,
  onNextMonthClick,
  onPreviousMonthClick,
  title,
}) => (
  <DatePickerHeaderContainer>
    <ChangeMonth
      isDisabled={isPrevMonthDisabled}
      onClick={onPreviousMonthClick}
      testid={'datePicker-previous-month-button'}
    />
    <Title data-testid="datePicker-current-month">{title}</Title>

    <ChangeMonth
      isDisabled={isNextMonthDisabled}
      onClick={onNextMonthClick}
      revert
      testid={'datePicker-next-month-button'}
    />
  </DatePickerHeaderContainer>
);

export default DatePickerHeader;
